import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { SPACE_SETTINGS_LANDING_PAGE } from '@confluence/named-routes/entry-points/routes.ts';
import { LoadablePaint } from '@confluence/loadable';
import {
	CONTAINER_ADMIN_HOME_ID,
	CONTAINER_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const LazySpaceStatusAndApprovalsRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-StatusAndApprovalsRouteComponent" */
				'./SpaceStatusAndApprovalsRouteComponent.tsx'
			)
		).SpaceStatusAndApprovalsRouteComponent,
});

export const LazySpaceStatusAndApprovalsRoute = ({ params: { spaceKey } }) => {
	if (!expVal('confluence_approvals_eap', 'isEnabled', false)) {
		return <Redirection name={SPACE_SETTINGS_LANDING_PAGE.name} params={{ spaceKey }} />;
	}

	return <LazySpaceStatusAndApprovalsRouteComponent spaceKey={spaceKey} />;
};

LazySpaceStatusAndApprovalsRoute.NAVIGATION_PARAMS = ({ params: { spaceKey } }, isNav4Enabled) => ({
	Screen: {
		pageState: { spaceKey },
		screenEvent: { name: 'statusAndApprovalsScreen' },
	},
	MainLayout: {
		navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		spaceKey,
	},
});
